// jscs:disable maximumLineLength
// const PRODUCTION = process.env.NODE_ENV === 'production';

const config = {
  // API_URL: "https://taplause-api.herokuapp.com/api/v2",
  // TAPLAUSE_API_URL: process.env.TAPLAUSE_API_URL,
  TAPLAUSE_NEW_API_BASE_URL: process.env.TAPLAUSE_NEW_API_BASE_URL,
  //TAPLAUSE_NEW_API_TOKEN: 'ShDT6iXcDRmoEh35TVkxGee5VjjaHooD',
  // TAPLAUSE_NEW_API_TOKEN: '8RbnY3J6VyNWemghifK8GY6bYnQ4z9x3',
  TARGET_URL: "https://go.taplause.com",
  TARGET_URL_DOMAIN: 'go.taplause.com',
  DASHBOARD_URL: "https://app.taplause.com/dashboard",
  // Env-driven so dev/staging/prod can use different Auth0 applications. Not a
  // secret (it ships in the bundle), but it is per-environment.
  AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: process.env.AUTH0_DOMAIN, // 'app51873638.eu.auth0.com',
  AUTH0_AUDIENCE: process.env.AUTH0_AUDIENCE,
  // Caps how long one access token is held in localStorage (the API issues 48h
  // ones); the refresher replaces it before this. NOT session length — that ends
  // at the 8h idle timeout, or when the refresh token expires. Becomes a no-op
  // once the API's own lifetime drops to 2h, but stays as this app's own ceiling.
  SESSION_MAX_SECONDS: 7200, // 2h
  SUPERUSER_KEY: 'isSuperuser',
  SUPERUSER_ACTIVE_KEY: 'isSuperuserActive',
  USER_TARGETS_KEY: 'user_targets',
  ERROR_TOKEN_EXPIRED: 'Bearer error="Expired token received for JSON Web Token validation"',
  PASSWORD_MIN_LENGTH: 8,
  QUESTIONS: [{
    en: [
      'What\'s up?',
      'Great to hear! Tell us more..',  // positive
      'Sad to hear :( Want to tell us more?', // negative
      'Add your contact info and you may win an activity tracker!', // contact form title
      'Thank you!', // thank you page
      'Please, tell us more.' // neutral
    ],
    fi: [
      'Mikä fiilis?',
      'Mahtavaa! Kerro lisää..',
      'Harmi :( Kerrotko lisää?',
      'Jätä yhteystietosi jos haluat osallistua aktiivisuusrannekkeen arvontaan',
      'Kiitos palautteestasi!',
      'Kerrotko lisää?'
    ]
  }, {
    en: [
      'How do we serve?',
      'Nice to hear. Please, tell us more...',
      'Sad to hear. Please, tell us more...',
      'Add your contact info and you may win an activity tracker!',
      'Thank you!',
      'Please, tell us more...'
    ],
    fi: [
      'Kuinka palvelemme?',
      'Kiva, mikä erityisesti jäi mieleesi?',
      'Harmi. Mikä meni pieleen?',
      'Jättämallä yhteystietosi osallistut aktiivisuusrannekkeen arvontaan',
      'Kiitos palautteestasi!',
      'Mikä erityisesti jäi mieleen?'
    ]
  }, {
    en: [
      'How was your stay?',
      'Great to hear! Tell us more..',
      'Sad to hear :( Is there some specific reason for this?',
      'Leave your contact details and we will contact you as soon as possible',
      'Thank you!',
      'Please, tell us more.'
    ],
    fi: [
      'Viihdyitkö?',
      'Mukava kuulla! Onnistuimmeko jossain erityisesti?',
      'Harmi, mikä meni pieleen?',
      'Jätä yhteystietosi, jos haluat että otamme yhteyttä',
      'Kiitos palautteestasi!',
      'Mitä jäi erityisesti mieleen?'
    ]
  }, {
    en: [
      'Are you satisfied?',
      'Great to hear! Please, tell us more..',
      'Sad to hear. Please, tell us more..',
      'Add your contact info and we\'ll contact you',
      'Thank you!',
      'Please, tell us more...'
    ],
    fi: [
      'Oletko tyytyväinen?',
      'Mukava kuulla! Onnistuimmeko jossain erityisesti?',
      'Harmi, mitä voisimme tehdä toisin?',
      'Jätä yhteystietosi, jos haluat että otamme yhteyttä',
      'Kiitos palautteestasi!',
      'Mitä jäi erityisesti mieleen?'
    ]
  }, {
    en: [
      'Based on your experience, how likely you would recommend this service to your friends?',
      'Great to hear! Please, tell us more..',
      'Sad to hear. Please, tell us more..',
      'Add your contact info and we\'ll contact you',
      'Thank you!',
      'Please, tell us more...'
    ],
    fi: [
      'Kuinka todennäköisesti suosittelisit tätä palvelua ystävillesi?',
      'Mukava kuulla! Onnistuimmeko jossain erityisesti?',
      'Harmi, mitä voisimme tehdä toisin?',
      'Jätä yhteystietosi, jos haluat että otamme yhteyttä',
      'Kiitos palautteestasi!',
      'Mitä jäi erityisesti mieleen?'
    ]
  }, {
    en: [
      'Feelings at work?',
      'Great to hear! Please, tell us more..',
      'Sad to hear. Please, tell us more..',
      'You may leave your name, if you would like to talk about it.',
      'Thank you!',
      'Please, tell us more...'
    ],
    fi: [
      'Mikä työfiilis?',
      'Kiva kuulla. Kerro mikä siihen erityisesti vaikuttaa...',
      'Harmi. Kerro mikä sen aiheuttaa. Miten voimme ratkaista asian yhdessä?',
      'Voit antaa nimesi, jos haluat jutella asiasta.',
      'Kiitos!',
      'Kerro vähän lisää...'
    ]
  }],
  PICTURES: [
    'https://taplause-app.s3.eu-central-1.amazonaws.com/wizard/default-images/taplause-default-images-1.jpg',
    'https://taplause-app.s3.eu-central-1.amazonaws.com/wizard/default-images/taplause-default-images-2.jpg',
    'https://taplause-app.s3.eu-central-1.amazonaws.com/wizard/default-images/taplause-default-images-3.jpg',
    'https://taplause-app.s3.eu-central-1.amazonaws.com/wizard/default-images/taplause-default-images-4.jpg'
  ],
  THEMES: [
      { value: 0, votingScale:  2, minValue: 0, maxValue: 1, label: 'Plus/Minus', iconPrefix: 'generic/pls'},
      { value: 1, votingScale: 11, minValue: 0, maxValue: 10, label: 'Net Promoter Score (NPS)', iconPrefix: 'generic/nps/svg'},
      { value: 2, votingScale:  5, minValue: 1, maxValue: 5, label: 'Feelings, 5', iconPrefix: 'generic/fls'},
      //{ value: 3, votingScale:  3, label: 'Reserved (do not use)', iconPrefix: ''},
      { value: 4, votingScale:  4, minValue: 1, maxValue: 4, label: 'Feelings, 4', iconPrefix: 'generic/sodexo'},
  ],
  MEASUREMENT_TYPES: [
    { value: 0, label: 'Plus/Minus'},
    { value: 1, label: 'Net Promoter Score (NPS)'},
    { value: 2, label: 'Feelings, 5'},
    { value: 4, label: 'Feelings, 4'},
  ],
  FEEDBACK_CATEGORIES: [
    { value: 0, label: 'Default'},
    { value: 1, label: 'Employee Net Promoter Score (eNPS)'},
    { value: 2, label: 'Customer feelings'},
    { value: 3, label: 'Employee feelings'},
  ],
  QRCODE_SCALE: [
    {value: 0, scale: 0.5, label: 'XXL - 4000x4000'},
    {value: 1, scale: 1, label: 'XL - 2000x2000'},
    {value: 2, scale: 2, label: 'L - 1000x1000'},
    {value: 3, scale: 4, label: 'M - 500x500'},
    {value: 4, scale: 8, label: 'S - 250x250'},
    {value: 5, scale: 16, label: 'XS - 125x125'},
    {value: 6, scale: 32, label: 'XXS - 64x64'},
  ],
  DASHBOARD_TYPES: [
    {value: 0, label: 'Default', type: 'default'},
    {value: 1, label: 'Public (only published feedback)', type: 'public'},
    {value: 2, label: 'Followup', type: 'followup'},
    {value: 3, label: 'Ethic (whistleblower)', type: 'ethic'},
  ],
  TARGET_TYPES: [
    {value: 0, label: 'Plus', path:'plus'},
    {value: 1, label: 'NPS', path:'nps'},
    {value: 2, label: 'Feelings', path:'fiilis'},
    {value: 3, label: 'Generic', path:'generic'},
  ],
  ANALYTICS_EMAILS: [
    {value: 0, label: 'None'},
    {value: 5, label: '5'},
    {value: 10, label: '10'},
    {value: 15, label: '15'},
  ],
  RATING_BUTTON_DEFAULT_VALUES: [
    {type: 'default', layout: null, status: false, comments: true, star: true, hide: false, close: false, publish: false, like: false},
    {type: 'public', layout: null, status: false, comments: false, star: false, hide: false, close: false, publish: false, like: true},
    {type: 'followup', layout: null, status: true, comments: true, star: true, hide: false, close: false, publish: false, like: false},
    {type: 'ethic', layout: null, status: false, comments: false, star: false, hide: false, close: false, publish: false, like: false},
    {type: 'default', layout: 'public', status: false, comments: false, star: false, hide: false, close: false, publish: false, like: true},
    {type: 'public', layout: 'public', status: false, comments: false, star: false, hide: false, close: false, publish: false, like: true},
    {type: 'followup', layout: 'public', status: false, comments: false, star: false, hide: false, close: false, publish: false, like: true},
    {type: 'ethic', layout: 'public', status: false, comments: false, star: false, hide: false, close: false, publish: false, like: true}
  ],
  RATING_BUTTON_HIDE: [
    {type: 'default', layout: null, status: false, comments: false, star: false, hide: false, close: false, publish: false, like: false, header: false},
    {type: 'public', layout: null, status: false, comments: false, star: false, hide: false, close: false, publish: false, like: false, header: false},
    {type: 'followup', layout: null, status: false, comments: false, star: false, hide: false, close: false, publish: false, like: false, header: false},
    {type: 'ethic', layout: null, status: true, comments: true, star: true, hide: true, close: true, publish: true, like: true, header: true},
    {type: 'default', layout: 'public', status: true, comments: true, star: false, hide: false, close: false, publish: false, like: false, header: false},
    {type: 'public', layout: 'public', status: true, comments: true, star: false, hide: false, close: false, publish: false, like: false, header: false},
    {type: 'followup', layout: 'public', status: true, comments: true, star: false, hide: false, close: false, publish: false, like: false, header: false},
    {type: 'ethic', layout: 'public', status: true, comments: true, star: true, hide: true, close: true, publish: true, like: true, header: true},
  ],
  /*
  DEFAULT_RULES: {
      show_tags: true,
      search: true,
      email_notifications: 5,
      show_contacts: true,
      show_private_id: true,
      excel: true,
      immediate: true,
      hourly: false,
      daily: false,
      show_pie_chart: false,
  }
  */
  //
  // Default values for taplause-dashboard rules.
  //
  DEFAULT_RULES : {
    authentication: false,
    auto_tags: false,
    change_target: false,
    customer: {},
    daily: true,
    email_notifications: 5,
    excel: true,
    hourly: true,
    immediate: true,
    locale_tags: false,
    locale: 'fi_FI',
    name: '_name_missing_',
    predefined_tags: '',
    reward_link: null,
    search: true,
    show_closed: false,
    show_contacts: true,
    show_custom: true,
    show_empty: true,
    show_feedback : true,
    show_fls_chart: false,
    show_fls_customer_chart: false,
    show_fls_employee_chart: false,
    show_overview_icon: false,
    show_hidden: false,
    show_history_chart: true,
    show_image: true,
    show_comments_btn: true,
    show_star_btn: true,
    show_hide_btn: false,
    show_close_btn: false,
    show_publish_btn: false,
    show_like_btn: false,
    enable_analytics: false,
    show_inappropriate: false,
    show_nps_chart: false,
    show_enps_chart: false,
    show_nps_dis_chart: false,
    show_pie_chart: false,
    show_posneg: null,
    show_private_id: true,
    show_tags_selector: false,
    show_tags: true,
    sms_notifications: 0,
    theme_id: 1,
    tag_url: null,
    time_from: '-infinity',
    time_to: 'infinity',
    weekly: true,
    layout: null,
    disabled: false,
    customer_id: 0,
    email_comments_enabled: false,
    email_comments_bcc: '',
    show_pls_chart: false,
    notification_link: false,
  },
};

// Named re-exports so `import { X } from '../constants/config'` keeps working, with
// TS inferring each value's type from the literal above.
export const {
  TAPLAUSE_NEW_API_BASE_URL, TARGET_URL, TARGET_URL_DOMAIN, DASHBOARD_URL,
  AUTH0_CLIENT_ID, AUTH0_DOMAIN, AUTH0_AUDIENCE,
  SESSION_MAX_SECONDS, SUPERUSER_KEY, SUPERUSER_ACTIVE_KEY, USER_TARGETS_KEY,
  ERROR_TOKEN_EXPIRED,
  PASSWORD_MIN_LENGTH, QUESTIONS, PICTURES, THEMES, MEASUREMENT_TYPES,
  FEEDBACK_CATEGORIES, QRCODE_SCALE, DASHBOARD_TYPES, TARGET_TYPES,
  ANALYTICS_EMAILS, RATING_BUTTON_DEFAULT_VALUES, RATING_BUTTON_HIDE, DEFAULT_RULES,
} = config;
export default config;
